import { joinURL } from 'ufo'

/**
 * Builds a Cloudflare Image Resizing URL (`cdn-cgi/image`) for an arbitrary source image URL.
 * Pure function — safe from Pinia stores, server handlers, and component `setup`.
 *
 * @param url - Absolute URL of the image to transform (e.g. Cloudflare Images delivery URL).
 * @param transform - Resizing options; keys/values are URL-encoded and joined with `=`, pairs with `,`.
 */
export function buildCloudflareExternalImgUrl(
    url: string,
    transform: Record<string, string | number>
): string {
    const normalizedTransform =
        Object.keys(transform).length > 0 ? transform : ({ format: 'auto' } as const)

    const transformString = Object.entries(normalizedTransform)
        .map(([key, value]) => `${encodeURIComponent(key)}=${encodeURIComponent(value)}`)
        .join(',')
    return joinURL('https://media-crane.com/cdn-cgi/image', transformString, url)
}
